import {ReactNode} from 'react';

import {CopyLink} from '../CopyLink';

import {Props} from './types';
import './styles.css';


const copyableValue = (value: ReactNode | string | number): value is string | number =>
  typeof value === 'string' || typeof value === 'number';

export const Property = ({
  label,
  value,
  disableCopy = false,
  hideValue = false,
}: Props) => (
  <div className="Property">
    <p className="Property_label">{label} {(!disableCopy && copyableValue(value)) && <CopyLink value={value}/>}</p>
    {!hideValue && <p className="Property_value">{'' + value}</p>}
  </div>
);
